import React from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { DragOverlay } from "@dnd-kit/core";
import { useMedia } from "use-media";

export function Item(props) {
  const { id, active, activeId } = props;
  const isPC = useMedia({ minWidth: '1000px' });

  const style = css`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    font-size: ${isPC ? "24px" : "20px"};
    user-select: none;
    width: calc(196px - 50px);
    transform: scale(${isPC ? "1" : "0.8"});
    height: ${id === activeId ? "40px" : "auto"};

    border: ${id === activeId ? "2px dashed gray" : "0px solid lightgray"};
    background-color: ${id === activeId ? "lightblue" : "white"};

    cursor: ${active ? "grabbing" : "grab"};

    position: relative;
    will-change: transform;
    touch-action: none;

    #red {
      border-bottom: 1px solid #55555530;
      text-align: start;
    }
    /* border: 1px solid black; */
    /* padding: 3px; */
    margin: 3px;
  `;


  return <>
    <div css={style} key={props.uniqueKey}>
      {
        id.includes("　") ? (
          <>
            <div id="red">{id}</div>
          </>
        ) : (
          <>
            {id}

          </>
        )
      }
    </div></>;
}

export default React.memo(function SortableItem(props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition
  } = useSortable({ id: props.id });

  const style = React.useMemo(() => ({
    willChange: transform,
    transform: CSS.Transform.toString(transform),
    transition,
  }), [transform, transition]);

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      {/* <DragOverlay> */}
      <Item id={props.id} isPrev={props.active} activeId={props.activeId} />
      {/* </DragOverlay> */}

    </div>
  );
});
